import React, { useState, useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import html2canvas from 'html2canvas';
import Modal from 'react-modal';
import Logo from '../images/Logo.png';
import CryptoJS from 'crypto-js'; // para HMAC

Modal.setAppElement('#root');

const SECRET_KEY = 'Laofi2024'; // ⚠️ Debe ser idéntico al usado en Flutter

const QRCodeGenerator = ({
  isOpen,
  onClose,
  userName,
  espacio,
  reservationDate,
  startTime,
  endTime,
  reservaId,
  idUser,
  idEspacio
}) => {
  const [qrData, setQrData] = useState('');

  // Función para ordenar las claves del objeto alfabéticamente
  const ordenarObjetoPorClave = (obj) => {
    return Object.keys(obj)
      .sort()
      .reduce((acc, key) => {
        acc[key] = obj[key];
        return acc;
      }, {});
  };

  const generateQRCodeData = () => {
    if (!reservaId || !idUser || !idEspacio) return;

    // Datos que se incluirán en el QR
    const qrPayload = {
      reservaId,
      idUser,
      idEspacio,
      fecha: reservationDate,
      horaInicio: startTime,
      horaFinal: endTime
    };

    // Ordenar claves antes de firmar para coincidir con Flutter
    const orderedPayload = ordenarObjetoPorClave(qrPayload);
    // Generar firma digital (HMAC-SHA256)
    const firma = CryptoJS.HmacSHA256(JSON.stringify(orderedPayload), SECRET_KEY).toString();

    const qrFinal = {
      ...qrPayload,
      firma
    };

    setQrData(JSON.stringify(qrFinal));
  };

  const downloadQRCodeAsImage = () => {
    const qrElement = document.getElementById('qrCode');
    html2canvas(qrElement).then((canvas) => {
      const imgUrl = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = imgUrl;
      link.download = `Qr-code-Reserva-${userName}.png`;
      link.click();
    });
  };

  useEffect(() => {
    if (isOpen) {
      generateQRCodeData();
    }
  }, [isOpen, reservaId, idUser, idEspacio]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Generar QR"
      className="modal-content"
    >
      <h1>QR de la Reserva</h1>
<p>¡Todo listo! Solo muestra este QR al llegar y comienza a disfrutar tu reserva.</p>
      <div id="qrCode">
        <QRCodeCanvas
          value={qrData}
          size={256}
          level="H"
          includeMargin={true}
          renderAs="canvas"
          fgColor="#000000"
          bgColor="#ffffff"
          imageSettings={{
            src: Logo,
            height: 80,
            width: 80,
            excavate: true,
          }}
        />
      </div>
<div>
<button onClick={downloadQRCodeAsImage}>Descargar QR</button>
      <button onClick={onClose}>Cerrar</button>
</div>
      
    </Modal>
  );
};

export default QRCodeGenerator;
